import { reactive } from "vue";

export const store = reactive({
    printers: [],
    setPrinters(printers) {
        this.printers = printers;
    },
    selectedPrinters: Array(3).fill(null),
    addSelectedPrinter(index, printer = null) {
        if (index >= this.selectedPrinters.length) {
            return;
        }

        if (printer === null || printer === "") {
            this.selectedPrinters[index] = null;
            return;
        }

        this.selectedPrinters[index] = printer || null;
    },
    removeSelectedPrinter(index) {
        this.selectedPrinters[index] = null;
    },
    loading: Array(3).fill(false),
    setLoading(index, isLoading) {
        this.loading[index] = isLoading;
    },
});

export default store;
